import styled from 'styled-components';

export const Wrapper = styled.div`
	margin-right: 0.5rem;
`;
